import ErrorMessage from "cui/components/error/ErrorMessage";
import { BackButton } from "cui/components/layouts/backButton/BackButton";
import PageHeader from "cui/components/pageHeader/PageHeader"
import { Button, Toolbar, Tooltip } from "devextreme-react"
import { Item } from "devextreme-react/toolbar"
import { useState } from "react";

type EmptyGridProps = {
    dataGridLabel : string,
    creationLabel: string,
    errorText: string,
    onClick: () => void,
    showBackButton: boolean;
    disabled?: boolean;
    disabledText?: string;
}

const EmptyGrid = (props: EmptyGridProps) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);

    return (
    <div className="is-table">
      <div className="cui-content-page">
            <Toolbar>
              <Item location="before">
                <div className="page-title-container"> 
                  {props.showBackButton && (
                  <>
                    <BackButton />
                    <div className="divider"></div>
                  </>
                  )}
                  <PageHeader text={props.dataGridLabel} />
                </div>
              </Item>
              <Item location="after">
						<div
							id="create-button"
							onMouseEnter={() => {if (props.disabled) setTooltipVisible(true)}}
							onMouseLeave={() => setTooltipVisible(false)}
						>
							<Button
                  icon="add"
                  text={props.creationLabel}
                  type="default"
                  stylingMode="contained"
                  onClick={props.onClick}
                  disabled={props.disabled ?? false}
              />
							<Tooltip
								target="#create-button"
								visible={tooltipVisible}
							>
								<div>{props.disabledText}</div>
							</Tooltip>
						</div>
						</Item>
            </Toolbar>
            <ErrorMessage iconName="error" errorText={props.errorText}/>
        </div>
      </div>
)};

export default EmptyGrid;